import React from "react";
import SearchInput from "../../common/Search";
import InfiniteScrollTable from "../../common/infinite-scroll";
import { auditLogDrCables, auditLogDrGasHandlers, auditLogDrGasSeparators, auditLogDrMotorLeads, auditLogDrMotors, auditLogDrMotorSensors, auditLogDrProtectors, auditLogDrPumps, auditLogDrSwitchBoard, auditLogDrVSD, auditLogSrAccAboveESP, auditLogSrAccBelowESP, auditLogSrBOH, auditLogSrCables, auditLogSrGasHandlers, auditLogSrGasSeparators, auditLogSrMLE, auditLogSrMotors, auditLogSrProtectors, auditLogSrPumps, auditLogSrTransformers, auditLogSrVSDs, auditLogHarmonicFilters } from "../../../constants/columns/equipment-catalog/equipmentCatalog";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import { CatalogType } from "../../../store/model/equipment-catalog/catalog";

interface IMyProjects {
    setCurrentParams?: any;
    currentParams?: any;
}

const AuditLog: React.FC<IMyProjects> = ({
    currentParams,
    setCurrentParams,
}) => {
    const { loading, dropdownOption, AuditLog } = useAppSelector((state) => state?.equipmentCatalog);

    const handleSortChange = (order: string, field: string): void => {
        if (order === "none") {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: "", Order: "" },
                PageNumber: 1,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: field, Order: order },
                PageNumber: 1,
            }));
        }
    };

    const handleSearchChange = (
        e: React.ChangeEvent<HTMLInputElement> | string
    ): void => {
        if (typeof e === "string") {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e,
                PageNumber: 1,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e?.target?.value,
                PageNumber: 1,
            }));
        }
    };

    const loadMore = () => {
        if (currentParams?.PageSize < AuditLog?.count) {
            setCurrentParams((prev: any) => {
                return ({
                    ...prev,
                    PageSize: prev?.PageSize + 10,
                })
            });
        }
    };

    return (
        <div className="w-full flex-1 gap-[16px] border-[1px] rounded-lg border-darkcolor-400 bg-darkcolor-700">
            <div className="w-full flex px-[24px] py-[20px] border-b border-darkcolor-400 text-[18px] text-neutral-25 font-semibold">
                Audit log
            </div>
            <div className="w-full flex-1 px-[24px] pt-[12px] pb-[20px]">
                <div className="flex flex-col md:flex-row justify-between items-center mb-[12px] space-y-4 md:space-y-0">
                    <div className="flex items-center justify-end w-full md:w-auto order-1 md:order-2">
                        <SearchInput
                            searchValue={currentParams?.GlobalFilter}
                            onSearchChange={handleSearchChange}
                            placeholder={"Search"}
                            bgColor="bg-darkcolor-800"
                            width={400}
                        />
                    </div>
                    <div className="flex items-center justify-start order-2 md:order-1 text-neutral-25">
                        {`Showing ${AuditLog?.data?.length} out of ${AuditLog?.count}`}
                    </div>
                </div>
                <div>
                    {dropdownOption?.id === CatalogType?.DRCables?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrCables]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRGasHandlers?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrGasHandlers]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRGasSeparators?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrGasSeparators]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRMotorLeads?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrMotorLeads]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRMotorSensors?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrMotorSensors]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRMotors?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrMotors]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRProtectors?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrProtectors]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRPumps?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrPumps]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRSwitchBoard?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrSwitchBoard]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.DRVSD?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogDrVSD]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRAccAboveESP?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrAccAboveESP]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRAccBelowESP?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrAccBelowESP]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRBOH?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrBOH]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRCables?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrCables]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRGasHandlers?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrGasHandlers]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRGasSeparators?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrGasSeparators]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRMLE?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrMLE]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRMotors?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrMotors]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRProtectors?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrProtectors]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRPumps?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrPumps]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRTransformers?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrTransformers]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.SRVSDs?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogSrVSDs]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                    {dropdownOption?.id === CatalogType?.HarmonicFilters?.toString() && (
                        <InfiniteScrollTable
                            data={AuditLog?.data || []}
                            columns={[...auditLogHarmonicFilters]}
                            onLoadMore={() => loadMore()}
                            rowsPerPage={1}
                            minimumHeight={300}
                            totalCount={AuditLog?.count}
                            overFlowClass="overflow-auto"
                            handleSortChange={handleSortChange}
                            initialSortField={currentParams?.SortDto?.Field}
                            initialSortOrder={currentParams?.SortDto?.Order}
                            isLoading={loading}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuditLog;
